import {
  SET_RENDER_LIST_PAGE,
  SET_RENDER_LIST_PAGE_TOTAL,
  SET_RENDER_LIST,
  SET_RENDER_LIST_QUERY,
  SET_RENDERING_LIST_QUERY,
  SET_RENDEREND_LIST_QUERY,
  SET_RENDERING_STATUS_LIST,
  SET_RENDEREND_STATUS_LIST,
  SET_RENDER_SORT,
  SET_RENDER_TASK_STATE_TYPE,
  SET_RENDER_LIST_PAGE_SIZE,
  SET_DETAIL_IMG_MESSAGE,
  SET_RENDER_TASK_COUNT,
  SET_RENDER_END_SEARCHING,
  SET_RENDER_RUNNING_SEARCHING,
  SET_RENDER_END_EXPORTING,
  SET_CONFIG_FILE,
  SET_MULTI_FRAME_CONFIG_FILE,
  IS_MULTI_FRAME,
  SET_JIGSAW_PREVIEW,
  RESET_RENDERING_LIST_QUERY,
  RESET_RENDEREND_LIST_QUERY,
  SET_FRAME_STATISTIC_MESSAGE,
  SET_TASK_SCENE_TYPE,
  SET_RENDER_TASK_LIST,
} from './mutation-types'
import files from 'file-saver'
import api from '@/api'
import _ from 'lodash'
import {getHeaderName} from '@/utils'
import {TaskType} from '../../../constants'

const query = (taskFlag) => ({
  pageNum: 1,                    // int-每页显示的记录数
  pageSize: 50,                  // int-页码
  userName: '',                  // String（条件查询 输入框 里面的参数）用户名
  userId: '',                    // String-条件查询 输入框 里面的参数）用户ID
  properties: '',                // string（条件查询 输入框 里面的参数）属性
  requirements: '',              // string（条件查询 输入框 里面的参数）要求
  constraints: '',               // string（条件查询 输入框 里面的参数）约束
  category: '',                  // string（条件查询 输入框 里面的参数）群组
  taskStatus: '',                // int（条件查询 下拉框 里面的参数）任务状态
  keywords: '',                  // String-平台id的字符串
  taskFlag: taskFlag,            // int-判断是运行还是渲染页面（0是运行，1是渲染）
  areaIds: '',                   // array（条件查询 下拉框 里面的参数）区域(SZ,SH)
  channel: '',                   // int（条件查询 下拉框 里面的参数）来源
  startTime: '',                 // timestamp-结束时间
  endTime: '',                   // timestamp-开始时间
  projectName: '',               // String-工程名
  sceneName: '',                 // String-场景名(文件名)
  failedFrameFlag: '',           // int（条件查询 筛选条件 里面的参数）失败帧
  isOverTimeFlag: '',            // int（条件查询 筛选条件 里面的参数）超时状态
  queryAdminId: '',              // int -（条件查询 下拉框 里面的参数）管理员
  isDelete: '',                  // ????
  taskIdFlag: '',                // int-根据任务ID号进行排序，值为1为升序，值为0为降序，否则为空
  executingFramesFlag: '',       // int-根据开始排序，值为1为升序，值为0为降序，否则为空
  doneFramesFlag: '',            // int-根据完成排序，值为1为升序，值为0为降序，否则为空
  abortFramesFlag: '',           // int-根据放弃帧排序，值为1为升序，值为0为降序，否则为空
  failFramesFlag: '',            // int-根据失败帧排序，值为1为升序，值为0为降序，否则为空
  startTimeFlag: '',             // int-根据开始时间排序，值为1为升序，值为0为降序，否则为空
  endTimeFlag: '',               // int-根据结束时间排序，值为1为升序，值为0为降序，否则为空
  taskLevelFlag: '',             // int-根据作业等级排序，值为1为升序，值为0为降序，否则为空
  consumeFlag: '',               // int-根据扣费排序，值为1为升序，值为0为降序，否则为空
  adminTagName: '',              // 管理员标签
})

const state = {
  searching: false,
  endSearching: false,
  endExporting: false,
  initIngQuery: query('0'),
  initEdQuery: query('1'),
  productRunning: {
    list: [],
    listPageTotal: 0,
    query: query('0'),
    sort: {
      submitTimeFlag: 0,
    },
    statusList: [],
  },
  renderCompleted: {
    list: [],
    listPageTotal: 0,
    query: query('1'),
    statusList: [],
    sort: {
      endTimeFlag: 0,
    },
  },
  stateType: {},
  imgMessage: {
    imgUrl: '',
    imgName: '',
  },
  countTask: {
    waiting: 0,
    running: 0,
    aborted: 0,
    failure: 0,
    success: 0,
    total: 0,
  },
  configList: {},
  multiFrameConfigList: {},
  isMultiFrame: false,
  jigsawPreview: false,
  frameTips: {},
  sceneType: '',
  renderTaskList: [],
}

const mutations = {
  [SET_RENDER_LIST] (state, payload) {
    state.stateType.list = payload
  },
  [SET_RENDER_LIST_PAGE] (state, payload) {
    state.stateType.query.pageNum = payload
  },
  [SET_RENDER_LIST_PAGE_TOTAL] (state, payload) {
    state.stateType.listPageTotal = payload
  },
  [SET_RENDER_LIST_QUERY] (state, payload) {
    state.stateType.query = payload
  },
  [SET_RENDERING_LIST_QUERY] (state, payload) {
    state.productRunning.query = {
      ...state.productRunning.query,
      ...payload,
    }
  },
  [SET_RENDEREND_LIST_QUERY] (state, payload) {
    state.renderCompleted.query = {
      ...state.renderCompleted.query,
      ...payload,
    }
  },
  [RESET_RENDERING_LIST_QUERY] (state, payload) {
    state.productRunning.query = payload
  },
  [RESET_RENDEREND_LIST_QUERY] (state, payload) {
    state.renderCompleted.query = payload
  },
  [SET_RENDERING_STATUS_LIST] (state, payload) {
    state.productRunning.statusList = payload
  },
  [SET_RENDEREND_STATUS_LIST] (state, payload) {
    state.renderCompleted.statusList = payload
  },
  [SET_RENDER_SORT] (state, payload) {
    state.stateType.sort = payload
  },
  [SET_RENDER_LIST_PAGE_SIZE] (state, payload) {
    state.stateType.query.pageSize = payload
  },
  [SET_RENDER_TASK_STATE_TYPE] (state, payload) {
    state.stateType = parseInt(payload) === 0 ? state.productRunning : state.renderCompleted
  },
  [SET_DETAIL_IMG_MESSAGE] (state, payload) {
    state.imgMessage = payload
  },
  [SET_RENDER_TASK_COUNT] (state, payload) {
    state.countTask = payload !== null ? payload : state.countTask
  },
  [SET_RENDER_RUNNING_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_RENDER_END_SEARCHING] (state, payload) {
    state.endSearching = payload
  },
  [SET_RENDER_END_EXPORTING] (state, payload) {
    state.endExporting = payload
  },
  [SET_CONFIG_FILE] (state, payload) {
    state.configList = payload
  },
  [SET_MULTI_FRAME_CONFIG_FILE] (state, payload) {
    state.multiFrameConfigList = payload
  },
  [IS_MULTI_FRAME] (state, payload) {
    state.isMultiFrame = payload
  },
  [SET_JIGSAW_PREVIEW] (state, payload) {
    state.jigsawPreview = payload
  },
  [SET_FRAME_STATISTIC_MESSAGE] (state, payload) {
    state.frameTips = payload
  },
  [SET_TASK_SCENE_TYPE] (state, payload) {
    state.sceneType = payload
  },
  [SET_RENDER_TASK_LIST] (state, payload) {
    state.renderTaskList = payload
  },
}

const actions = {
  // 运行的渲染作业列表
  async getRenderList ({commit, state}, statusFlag) {
    try {
      if (statusFlag !== undefined) commit(SET_RENDER_TASK_STATE_TYPE, statusFlag)
      let query = {}
      _.forIn(state.stateType.query, (v, k) => {
        v = v === true ? 1 : v === false ? '' : v
        if (k === 'keywords' || v !== '') {
          query[k] = v
        }
      })
      if (query['taskStatus']) delete query['taskFlag']
      if (typeof query['areaIds'] === 'string') query['areaIds'] = [parseInt(query['areaIds'])]
      let params = {
        ...query,
        ...state.stateType.sort,
        taskTypes: [TaskType.Render, TaskType._3DTiles, TaskType.Tiff],
      }
      if (statusFlag === '1') commit(SET_RENDER_END_SEARCHING, true)
      else commit(SET_RENDER_RUNNING_SEARCHING, true)
      const {data: {items, total}} = await api.dayanTaskApi.getBuildEndTaskList(params)
      commit(SET_RENDER_RUNNING_SEARCHING, false)
      commit(SET_RENDER_END_SEARCHING, false)
      items.map((itm, idx) => {
        itm.taskFlag = query.taskFlag
        // if (idx % 3 === 0) itm.photon = 1 // 1, 为光子停止， 2，为光子失败
        // else itm.photon = 2
      })
      // 初始化父任务的展开状态以及对子任务的标记
      commit(SET_RENDER_LIST_PAGE_TOTAL, total)
      commit(SET_RENDER_LIST, items)
    } catch (error) {
      commit(SET_RENDER_RUNNING_SEARCHING, false)
      commit(SET_RENDER_END_SEARCHING, false)
      commit(SET_RENDER_LIST_PAGE_TOTAL, 0)
      commit(SET_RENDER_LIST, [])
    }
  },
  // 初始化列表
  async initRenderList ({commit, state, dispatch}, statusFlag) {
    commit(SET_RENDER_TASK_STATE_TYPE, statusFlag)
    commit(SET_RENDER_LIST_PAGE, 1)
    commit(SET_RENDER_LIST_PAGE_SIZE, 50)
    await dispatch('getRenderList', statusFlag)
    if (statusFlag === 0) {
      await dispatch('queryTaskOfPlatformStat')
    }
  },
  // 运行的渲染作业列表翻页
  changeRenderListPage ({commit, state, dispatch}, {currentPage}) {
    commit(SET_RENDER_LIST_PAGE, currentPage)
  },
  // 运行的渲染作业排序
  changeRenderSort ({commit, dispatch}, payload) {
    commit(SET_RENDER_SORT, payload)
    dispatch('changeRenderListPage', {currentPage: 1})
    dispatch('getRenderList')
  },
  // 筛选渲染作业
  async changeRenderingQuery ({commit, dispatch}, payload) {
    commit(SET_RENDERING_LIST_QUERY, payload)
    await dispatch('getRenderList', 0)
  },
  async changeRenderendQuery ({commit, dispatch}, payload) {
    commit(SET_RENDEREND_LIST_QUERY, payload)
    await dispatch('getRenderList', 1)
  },
  // 设置筛序渲染作业的筛选条件
  setRenderingQuery ({commit}, payload) {
    commit(SET_RENDERING_LIST_QUERY, payload)
  },
  // 开始状态
  // eslint-disable-next-line
  async productStartTask ({}, payload) {
    const data = await api.dayanTaskApi.startTask(payload)
    return data
  },
  setRenderendQuery ({commit}, payload) {
    commit(SET_RENDEREND_LIST_QUERY, payload)
  },
  // 重置筛选参数
  resetProductingQuery ({commit, state}) {
    commit(RESET_RENDERING_LIST_QUERY, state.initIngQuery)
  },
  resetProductendQuery ({commit, state}) {
    commit(RESET_RENDEREND_LIST_QUERY, state.initEdQuery)
  },
  // 重置排序
  resetRenderSort ({dispatch}) {
    dispatch('changeRenderSort', {})
  },
  // 改变每页显示条数
  changePageSize ({commit, dispatch}, payload) {
    commit(SET_RENDER_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeRenderListPage', {currentPage: 1})
  },
  // 停止状态
  // eslint-disable-next-line
  async rendingStopTask ({}, payload) {
    const data = await api.dayanTaskApi.stopTask({taskIds: payload})
    return data
  },
  // 修改级别按钮
  // eslint-disable-next-line
  async updateLevel ({}, payload) {
    const data = await api.dayanTaskApi.updateLevel(payload)
    return data
  },
  // 修改节点数量按钮
  // eslint-disable-next-line
  async updateNodeLimit ({}, payload) {
    const data = await api.dayanTaskApi.updateNodeLimit(payload)
    return data
  },
  // 设置超时时间
  // eslint-disable-next-line
  async setTaskOverTime ({}, payload) {
    const data = await api.dayanTaskApi.setTaskOverTimeStop(payload)
    return data
  },
  // 查看生产日志
  // eslint-disable-next-line
  async getProductLog ({}, payload) {
    const {code, data} = await api.dayanTaskApi.getProductLog(payload)
    return code === 200 ? data : []
  },
  // 删除任务
  // eslint-disable-next-line
  async deleteTask ({}, payload) {
    const data = await api.dayanTaskApi.deleteTask(payload)
    return data
  },
  // 导出作业Excel
  async exportTaskExcel ({commit, state}, payload) {
    commit(SET_RENDER_END_EXPORTING, true)
    const query = {}
    for (let key in state.stateType.query) {
      if (state.stateType.query[key] || state.stateType.query[key] === 0) query[key] = state.stateType.query[key]
    }
    const {data, headers} = await api.dayanTaskApi.exportTaskExcel({
      ...payload,
      ...query,
    })
    commit(SET_RENDER_END_EXPORTING, false)
    const fileName = getHeaderName(headers).replace(/\"/g, '')
    const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
    files.saveAs(blob, fileName)
  },
  setDetailImgMessage ({commit}, payload) {
    commit(SET_DETAIL_IMG_MESSAGE, payload)
  },
  clearDetailImgMessage ({commit}) {
    commit(SET_DETAIL_IMG_MESSAGE, {})
  },
  // 运行的渲染作业统计
  async queryTaskOfPlatformStat ({commit}) {
    const data = await api.dayanTaskApi.queryTaskOfPlatformStat()
    if (data.result) {
      commit(SET_RENDER_TASK_COUNT, data.data)
    }
  },
  // 恢复任务
  async regainTask ({commit}, payload) {
    const data = await api.dayanTaskApi.regainTask(payload)
    return data
  },
  // 查看历史重渲记录
  async getHistoryRenderInfo ({commit}, payload) {
    const {data} = await api.dayanTaskApi.getHistoryRenderInfo(payload)
    if (data === 'MUNU_NO_RESOURCES') return []
    else return data
  },
  // 单个用户所有金额统计
  async queryAmount ({commit}, payload) {
    const {data, result} = await api.dayanTaskApi.queryAmount(payload)
    return {data, result}
  },
  // 更新修改标签
  async updateTaskLabel ({commit}, payload) {
    const {data, result, code, message} = await api.dayanTaskApi.updateTaskLabel(payload)
    return {data, result, code, message}
  },
  // 新增管理员标签
  async addAdminLabel ({commit}, payload) {
    const {code, message} = await api.dayanTaskApi.addAdminLabel(payload)
    return {code, message}
  },
  // 删除管理员标签
  async deleteAdminLabel ({commit}, payload) {
    const {code, message} = await api.dayanTaskApi.deleteAdminLabel(payload)
    return {code, message}
  },
  // 获取管理员标签
  async getAdminLabel ({commit}, payload) {
    const {data, code, message} = await api.dayanTaskApi.getAdminLabel(payload)
    return {data, code, message}
  },
  // 给任务添加标签
  async addTaskAdminLabel ({commit}, payload) {
    const {code, message} = await api.dayanTaskApi.addTaskAdminLabel(payload)
    return {code, message}
  },
  // 获取提交失败的错误信息
  async getSubmitTaskFailMessage ({commit}, taskId) {
    const {code, data} = await api.dayanTaskApi.getSubmitTaskFailMessage({taskId})
    return {code, data}
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
